// feedback form component

import { trpc } from "@sens/web/lib/trpc"
import React from "react"

export const FeedbackForm = () => {
  const submitFeedback = trpc.submitFeedback.useMutation()
  const [feedback, setFeedback] = React.useState("")
  const [message, setMessage] = React.useState("")

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    await submitFeedback.mutateAsync({ feedback })
    setFeedback("")
    setMessage("Thank you for your feedback!")
  }

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-2">
      <textarea
        value={feedback}
        rows={4}
        autoFocus
        onChange={(e) => setFeedback(e.target.value)}
        className="textarea textarea-bordered textarea-tw w-full"
        placeholder="How can we improve?"
      />
      {message && <div className="text-sky-800">{message}</div>}
      <div className="self-end">
        <button type="submit" className="btn btn-sm btn-secondary">
          Submit
        </button>
      </div>
    </form>
  )
}
